<template>
  <v-row>
    <v-col cols="10">
      <v-card tile :loading="loading">
        <v-alert border="bottom" colored-border type="error" v-if="error">
          <span class="body-1">{{ error }}</span>
        </v-alert>
        <template v-if="client">
          <v-toolbar flat class="pt-4 ">
            <v-toolbar-title class="font-weight-bold headline">
              {{ client.first_name | title }} {{ client.last_name | title }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              rounded
              v-if="!client.email_verified_at"
              :loading="sendingVerificationEmail"
              @click="sendVerificationEmail"
              :disabled="sendingVerificationEmail || sentVerificationEmail"
            >
              <v-icon>mdi-email-check-outline</v-icon>
              Verify Email Address
            </v-btn>
            <div class="d-flex align-center" v-else>
              <span class="title"> Verification status:</span>
              <v-icon size="50" color="primary">
                mdi-progress-check
              </v-icon>
            </div>
          </v-toolbar>
          <v-divider />
          <v-list dense>
            <v-list-item>
              <v-list-item-content>Company:</v-list-item-content>
              <v-list-item-content class="outline">{{ client.company }}</v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>Email:</v-list-item-content>
              <v-list-item-content class="outline">{{ client.email }}</v-list-item-content>
            </v-list-item>
            <v-divider />
            <v-list-item>
              <v-list-item-content>Admin URL:</v-list-item-content>
              <v-list-item-content>
                {{ client.admin_url || 'Un available' }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>API URL:</v-list-item-content>
              <v-list-item-content>
                {{ client.api_url || 'Un available' }}
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>API Token:</v-list-item-content>
              <v-list-item-content>
                {{ client.token || 'Un available' }}
              </v-list-item-content>
            </v-list-item>

            <v-divider />

            <v-list-item>
              <v-list-item-content>API secret:</v-list-item-content>
              <v-list-item-content>
                <span>
                  {{ showSecret ? client.secret || 'un available' : '*********************' }}
                </span>
              </v-list-item-content>
              <v-list-item-action class="align-end pink--text">
                <v-btn @click="showSecret = !showSecret" rounded color="primary" outlined
                  ><v-icon>
                    {{ showSecret ? 'mdi-eye-check-outline' : 'mdi-eye-off-outline' }}
                  </v-icon></v-btn
                >
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </template>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import get from 'lodash/get';
import capitalize from 'lodash/capitalize';
export default {
  mounted() {
    const url = this.$route.query.profileUrl;

    if (!url) {
      this.error = 'Invalid profile url';
      return;
    }

    this.loading = true;
    this.$http
      .get(url)
      .then(client => {
        this.client = client;
      })
      .catch(response => {
        this.error = this.getErrorMessage(response);
      })
      .finally(() => {
        this.loading = false;
      });
  },

  filters: {
    title(value) {
      return capitalize(value);
    },
  },
  data() {
    return {
      error: null,
      client: null,
      loading: false,
      showSecret: false,
      sendingVerificationEmail: false,
      sentVerificationEmail: false,
    };
  },
  methods: {
    sendVerificationEmail() {
      this.sendingVerificationEmail = true;
      this.$http
        .post(`api/v1/clients/${this.client.id}/sendVerficationEmail`)
        .then(() => {
          Notify.success('Email verification link was sent successfully to your link');
          this.sentVerificationEmail = true;
        })
        .catch(error => {
          Notify.error(this.getErrorMessage(error), { close: false });
        })
        .finally(() => {
          this.sendingVerificationEmail = false;
        });
    },
    getErrorMessage(error) {
      return get(error, 'response.data.message', get(error, 'message', 'Something went wrong'));
    },
  },
};
</script>
